import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useAlert, useLearningHistory, useUserInfo } from '../../../hooks';
import Header from './Header';
import Note from './Note';
import Tab from './Tab';

function LearningNoteGB({ id }) {
  const location = useLocation();
  const { t } = useTranslation();
  const state = sessionStorage.getItem('state');
  const { learningHistoryInfo, onLearninStartBtn} = useLearningHistory();
  const [Alert] = useAlert();
  const [tab, setTab] = useState(location.state ? location.state : state ? state : 'course_tab1');
  const history = useHistory();
  const { info } = useUserInfo();
  const [payPopupInfo, setPayPopupInfo] = useState({
    isShow: false,
    prevTab: tab
  });

  useEffect(() => {
    sessionStorage.setItem('lastPath', location.pathname);
  }, [])

  useEffect(() => {
    sessionStorage.setItem('state', tab);
  }, [tab])

  const handleTab = useCallback((tab) => {
    console.log("tab", tab);
    const { isPaymentCountry, subScriptionPurchsYn } = info;

    if(tab === 'course_tab1' && isPaymentCountry && !subScriptionPurchsYn) {
      setPayPopupInfo({
        isShow: true,
        prevTab: tab
      });
    } else {
      if (tab === 'course_tab1' && learningHistoryInfo.isCompleteAIDiagnosis === 'N') {
        const curLocation = history.location.pathname;
        
        Alert(
          t("LC_01_02_lp.msg001"),
          () => {
            onLearninStartBtn({
              viewPath : curLocation
            });
          }
        )
        
        return;
      }
    }
    
    setTab(tab);
  }, [tab]);

  const handleClosePayPopup = useCallback(() => {
    setPayPopupInfo({
      isShow: false,
      prevTab: tab
    });
    setTimeout(() => setTab(payPopupInfo.prevTab));
  }, []);
  
  return (
    <React.Fragment>
      <Header />
      <div className="layout-def tab-wrap gb with_header">
        <Tab
          tab={tab}
          handleTab={handleTab}
        />
        <Note 
          id={id} 
          tab={tab} 
          isShowPayPopup={payPopupInfo.isShow}
          onClosePayPopup={handleClosePayPopup}
        />
      </div>
    </React.Fragment>
  );
}

export default LearningNoteGB;